import React, { useState, useEffect } from "react";
import axios from "axios";
import Fleg from "../../Assets/Header/Flag.png";
import trade from "../../Assets/Dasahboard/trade.png";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { API } from "../../Utility/API";
import { updateAuth } from "../../Redux/AuthSlice";
import "../Profile/Profile.css";
import SidebarBOT from "../Sidebar/SidebarBOT";
import logo from "../../Assets/Images/logo.png";
import IconA from "../../Assets/sidebar/icon1.png";
import toast from "react-hot-toast";
export default function Profile() {
  const [userid, setUserId] = useState("");
  const [username, setUserName] = useState("");
  const [toDate, setToDate] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [rank_val, setrank_val] = useState("0");

  const [status_val, setStatus] = useState("2");
  const [postion_val, setPosition] = useState("0");
  const [referralApi, setreferralApi] = useState([]);
  const [currentPage, setcurrentPage] = useState(1);
  const [listPerpage, setlistPerpage] = useState(10);
  const [totalClaimAmount, setTotalClaimAmount] = useState(0);
  const [totalinvestAmount, setTotalinvestAmount] = useState(0);
  const [pincode, setpincode] = useState("");

  const [Password, setPassword] = useState("");
  const [Cpassword, setCpassword] = useState("");

  const [Ccpassword, setCcpassword] = useState("");
  const dispatch = useDispatch();

  const navigate = useNavigate();

  const [search, setSearch] = useState("");
  const { userId, jwtToken } = useSelector((state) => state.Auth);
  const [dash, setdataArray] = useState([]);
  const [profileData, setprofileData] = useState([]);
  const [tabname, settabname] = useState("");

  const [countries, setCountries] = useState([]);
  const [stateList, setstateList] = useState([]);
  const [stateNewList, setstateNewList] = useState("");
  const [districtList, setdistrictList] = useState([]);
  const [districtNewList, setdistrictNewList] = useState("");
  const [ipAddress, setIP] = useState("");

  const [otp_flag, setotp_flag] = useState(false);

  const [AStatus, setAStatus] = useState(0);

  const [ecurrency, setecurrency] = useState("");
  const [ecurrencyNew, setecurrencyNew] = useState("");

  const [Bankotp_flag, setBankotp_flag] = useState(false);
  const [BankAccountNo, setBankAccountNo] = useState("");
  const [HolderName, setHolderName] = useState("");
  const [IFSCode, setIFSCode] = useState("");
  const [BranchName, setBranchName] = useState("");
  const [BankName, setBankName] = useState("");

  useEffect(() => {
    GetUserDetails();
    GetUserProfileDetails();
    CountryList_API();
  }, []);

  const sendOTP = async () => {
    try {
      if (!ecurrencyNew) {
        toast.error("Please enter a valid wallet address");
        return;
      } else if (!profileData?.email) {
        toast.error("Please enter email address");
        return;
      }
      let res = await API.post("/Wallettupdate", {
        Email: profileData?.email,
      });
      //console.log("resopt", res);
      if (res.data.data === "Successfull") {
        setotp_flag(true);
        toast.success("OTP sent successfully!");
      }
    } catch (error) {
      console.log(error);
    }
  };

  const sendBankOTP = async () => {
    try {
      if (!BankAccountNo) {
        toast.error("Please enter Bank Account No.");
        return;
      } else if (!HolderName) {
        toast.error("Please enter Account Holder Name");
        return;
      } else if (!IFSCode) {
        toast.error("Please enter IFSC Code");
        return;
      } else if (!BankName) {
        toast.error("Please enter Bank Name");
        return;
      } else if (!BranchName) {
        toast.error("Please enter Branch Name");
        return;
      }
      let res = await API.post("/BankUpdateOTP", {
        Email: profileData?.email,
      });
      //console.log("resopt", res);
      if (res.data.data === "Successfull") {
        setBankotp_flag(true);
        toast.success("OTP sent successfully!");
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchIPAddress = async () => {
    try {
      const response = await axios.get("https://api64.ipify.org/?format=json");
      setIP(response.data.ip);
      return response.data.ip;
    } catch (error) {
      console.error("Error fetching IP address", error);
      toast.error("Unable to fetch IP address.");
      return null;
    }
  };

  const fetchBankDetails = async (ifc_code) => {
    try {
      setIFSCode(ifc_code);
      const response = await fetch(`https://ifsc.razorpay.com/${ifc_code}`);
      if (!response.ok) {
        throw new Error("Invalid IFSC code");
      }
      const data = await response.json();
      console.clear();
      console.log("BankDetails-->", data);
      setBankName(data?.BANK);
      setBranchName(data?.BRANCH);
      // setBankName(details);
      // setError(null);
    } catch (err) {
      // setError("Invalid IFSC code or network issue");
      // setBankDetails(null);
    }
  };

  const GetUserDetails = async () => {
    try {
      let responce = await API?.post(
        "userdashboard",
        {
          uid: userId,
          type: 2,
        },
        {
          headers: {
            Authorization: `${jwtToken}`,
          },
        }
      );
      responce = responce.data.data[0];
      setdataArray(responce);
    } catch (e) {
      //console.log("userDetails error", e);
      // console.log("userDetails error", e.response.data);
      if (
        e.response.data.showableMessage ==
        "Please login to access this resource"
      ) {
        dispatch(
          updateAuth({
            wtcAuth: false,
            token: null,
            userId: null,
            ipAddress: null,
          })
        );
        navigate("/");
      }
    }
  };

  const [ProfileName, setProfileName] = useState("");
  const [Email, setEmail] = useState("");
  const [MobileNo, setMobileNo] = useState("");
  const [CountryId, setCountryId] = useState(0);
  const GetUserProfileDetails = async () => {
    try {
      let responce = await API?.post(
        "UserInformation",
        {
          uid: userId,
        },
        {
          headers: {
            Authorization: `${jwtToken}`,
          },
        }
      );
      responce = responce.data.data[0];
      StateList_API(responce?.countryid);
      setstateNewList(responce?.stateid);
      setpincode(responce?.pincode);
      setprofileData(responce);
      setProfileName(responce?.f_name);
      setEmail(responce?.email);
      setMobileNo(responce?.mobile);
      setCountryId(responce?.countryid);
      setecurrencyNew(responce?.accountnumber);
      if (
        parseInt(responce.top_up_BOT) === 0 ||
        parseInt(responce.top_up_fix) === 0 ||
        parseInt(responce.top_up_fix_trading) === 0 ||
        parseInt(responce.top_up_forex) === 0
      ) {
        setAStatus(0);
      } else {
        setAStatus(1);
      }
      DistrictList_API(responce?.stateid);
      setdistrictNewList(responce?.districtid);
      setecurrency(responce?.accountnumber);

      setBankAccountNo(responce?.bankAccountNo);
      setHolderName(responce?.holder);
      setBankName(responce?.bank_name);
      setBranchName(responce?.branch);
      setIFSCode(responce?.ifsc);
    } catch (e) {
      //console.log("userDetails error", e);
      // console.log("userDetails error", e.response.data);
      if (
        e.response.data.showableMessage ==
        "Please login to access this resource"
      ) {
        dispatch(
          updateAuth({
            wtcAuth: false,
            token: null,
            userId: null,
            ipAddress: null,
          })
        );
        navigate("/");
      }
    }
  };

  const CountryList_API = async () => {
    try {
      let res = await API.get("countryList");
      const fetchedCountries = res.data.data[0];
      //console.log("res.data.data==>",res.data.data)
      setCountries(fetchedCountries);

      // if (fetchedCountries[98]) {
      //   setSelectedCountry(fetchedCountries[98].name);
      //   setMobileCode(fetchedCountries[98].phonecode);
      // }
    } catch (error) {
      console.log("Country API ERROR", error);
    }
  };

  const checkpin = async (e) => {
    let { value } = e.target;
    //const newValue = value.replace(/[^A-Za-z0-9]/g, "");
    const newValue = value;
    if (newValue === "") {
      setpincode(profileData?.pincode);
    } else {
      setpincode(newValue);
    }
  };

  const checkCountry = async (e) => {
    let newValue = e.target.value;
    if (newValue === "") {
      setstateList([]);
      setdistrictList([]);
    } else {
      setCountryId(newValue);
      StateList_API(newValue);
    }
  };

  const checkState = async (e) => {
    let newValue = e.target.value;
    if (newValue === "") {
      // profileData?.stateId
      setstateNewList(profileData?.stateId);
    } else {
      setstateNewList(newValue);
      //setstateNewname(e.target.name);
      DistrictList_API(newValue);
    }
  };

  const checkDistrict = async (e) => {
    let newValue = e.target.value;
    if (newValue === "") {
      // profileData?.districtid
      setdistrictNewList(profileData?.stateId);
    } else {
      setdistrictNewList(newValue);
    }
  };

  const StateList_API = async (CountryId) => {
    //  console.log("CountryId",CountryId)
    try {
      let response = await API?.post(
        "getregion",
        {
          uid: userId,
          regiontype: "State",
          regionid: CountryId,
        },
        {
          headers: {
            Authorization: `${jwtToken}`,
          },
        }
      );
      //  console.log("responseCountryId-->",CountryId, response.data.data[0]);
      const fetchedStates = response.data.data[0];
      setstateList(fetchedStates);
    } catch (error) {
      //console.log("Country API ERROR", error);
    }
  };

  const DistrictList_API = async (stateId) => {
    try {
      let response = await API?.post(
        "getregion",
        {
          uid: userId,
          regiontype: "District",
          regionid: stateId,
        },
        {
          headers: {
            Authorization: `${jwtToken}`,
          },
        }
      );
      //console.log("response-->", response.data.data[0]);
      const fetchedStates = response.data.data[0];
      setdistrictList(fetchedStates);
    } catch (error) {
      console.log("Country API ERROR", error);
    }
  };

  const MyTeam_API = async () => {
    try {
      // let responce = await API?.post(
      //   `/MyTeamReport`,
      //   {
      //     uid: userid || userId,
      //     level: "0",
      //     type: "",
      //     status: "2",
      //   },
      //   {
      //     headers: {
      //       Authorization: `${jwtToken}`,
      //       "Content-Type": "application/json",
      //     },
      //   }
      // );
      // console.log("MyTeamReport", responce.data.data[0]);
      // responce = responce.data.data[0];
      // let arr = [];
      // let totalClaimAmount = 0;
      // let totalinvestAmount = 0;
      // responce.forEach((item, index) => {
      //   const claimAmount = parseFloat(item.claimAmount) || 0;
      //   totalClaimAmount += claimAmount;
      //   const investAmount = parseFloat(item.totalPackage) || 0;
      //   totalinvestAmount += investAmount;
      //   arr.push({
      //     sr: item.row,
      //     uid: item.uid,
      //     Registration_Date: item.date1,
      //     Position: item.position,
      //     // Wallet: `${item.wallet.substring(0, 6)}...${item.wallet.substring(
      //     //   item.wallet.length - 4
      //     // )}`,
      //     Status: item.st === 1 ? "Active" : "Inactive",
      //     packagename: item.currentPackage,
      //     top_update1: item.top_update1,
      //     Latest_Package: item?.currentPackage,
      //     Gross_Package:
      //       parseInt(item.st) === 1 ? <>{item?.totalPackage} USD</> : <></>,
      //     claimstatus: item.claimstatus,
      //     claimdate: item.claimdate,
      //     claimAmount: item.claimAmount,
      //   });
      // });
      // setreferralApi(arr);
      // setTotalinvestAmount(totalinvestAmount);
      // setTotalClaimAmount(totalClaimAmount);
    } catch (e) {
      console.log("Error While calling Referrer API", e);
      if (
        e.response.data.showableMessage ===
        "Please login to access this resource"
      ) {
        dispatch(
          updateAuth({
            aexnglobalAuth: false,
            userId: null,
            jwtToken: null,
            ipAddress: null,
          })
        );
        navigate("/");
      }
    }
  };

  const Updateprofile = async () => {
    try {
      const ipaddress = await fetchIPAddress();
      if (!ipaddress) return;
      if (!stateNewList) {
        toast.error("Please select state name");
        return;
      } else if (!districtNewList) {
        toast.error("Please select district name");
        return;
      } else if (!pincode) {
        toast.error("Please enter pincode");
        return;
      }
      let res = await API.post(
        "/UpdateProfile",
        {
          type: "profile",
          stateid: Number(stateNewList),
          districtId: Number(districtNewList),
          pincode: pincode,
          uid: userId,
          IP_address: ipaddress,
          f_name: ProfileName,
          email: Email,
          mobile: MobileNo,
          counrtyid: CountryId,
        },
        {
          headers: {
            Authorization: `${jwtToken}`,
          },
        }
      );

      if (res.data.data.Result === "Profile Update Successfully") {
        toast.success(`${res.data.data.Result}`);
      } else {
        toast.error(`${res.data.data.Result}`);
      }
    } catch (error) {
      console.log("API ERROR", error);
    }
  };

  const Updateprofilepassword = async () => {
    try {
      const ipaddress = await fetchIPAddress();
      if (!ipaddress) return;
      if (!Ccpassword) {
        toast.error("Please enter current password");
        return;
      } else if (!Password) {
        toast.error("Please enter new password");
        return;
      } else if (!Cpassword) {
        toast.error("Please enter confirm password");
        return;
      } else if (Password == Ccpassword) {
        toast.error("Old password can not be new password");
        return;
      } else if (Password != Cpassword) {
        toast.error("Password is not matched");
        return;
      }
      let res = await API.post(
        "/UpdateProfile",
        {
          type: "password",
          password: Password,
          cpassword: Ccpassword,
          uid: userId,
          IP_address: ipaddress,
        },
        {
          headers: {
            Authorization: `${jwtToken}`,
          },
        }
      );
      if (res.data.data.Result === "Current password is wrong!") {
        toast.error(`Current password is wrong!`);
        return;
      }
      if (res.data.data.Result === "Password Updated Successfully") {
        toast.success(`Password Updated Successfully`);
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      } else {
        toast.error(`${res.data.data.Result}`);
      }
    } catch (error) {
      console.log("API ERROR", error);
    }
  };

  const Updatewallet = async () => {
    try {
      const ipaddress = await fetchIPAddress();
      if (!ipaddress) return;
      if (!ecurrencyNew) {
        toast.error("Please enter wallet address");
        return;
      } else if (!otp_flag) {
        toast.error("Please enter otp");
        return;
      }
      let res = await API.post(
        "/UpdateProfile",
        {
          type: "ecurrency",
          accountnumber: ecurrencyNew,
          otp: otp_flag,
          uid: userId,
          email: profileData?.email,
          IP_address: ipaddress,
        },
        {
          headers: {
            Authorization: `${jwtToken}`,
          },
        }
      );
      if (res.data.data === "Current password is wrong!") {
        toast.error(`Current password is wrong!`);
        return;
      }

      if (res.data.data.Result === "Wallet Address Update Successfully") {
        toast.success(`${res.data.data.Result}`);
      } else if (res.data.data === "Wrong OTP!") {
        toast.error(`${res.data.data}`);
      } else {
        toast.error(`${res.data.data.Result}`);
      }
    } catch (error) {
      console.log("API ERROR", error);
    }
  };

  const UpdateBankDetails = async () => {
    try {
      const ipaddress = await fetchIPAddress();
      if (!ipaddress) return;
      if (!BankAccountNo) {
        toast.error("Please enter Bank Account No.");
        return;
      } else if (!HolderName) {
        toast.error("Please enter Account Holder Name");
        return;
      } else if (!IFSCode) {
        toast.error("Please enter IFSC Code");
        return;
      } else if (!BankName) {
        toast.error("Please enter Bank Name");
        return;
      } else if (!BranchName) {
        toast.error("Please enter Branch Name");
        return;
      }
      let res = await API.post(
        "/UpdateProfile",
        {
          type: "UpdateBankDetails",
          accountnumber: BankAccountNo,
          bank_name: BankName,
          ifsc: IFSCode,
          holder: HolderName,
          branch: BranchName,
          otp: Bankotp_flag,
          uid: userId,
          email: profileData?.email,
          IP_address: ipaddress,
        },
        {
          headers: {
            Authorization: `${jwtToken}`,
          },
        }
      );
      console.log("res-->", res);

      if (res.data.data.Result === "Bank Details Update Successfully") {
        toast.success(`${res.data.data.Result}`);
      } else if (res.data.data === "Wrong OTP!") {
        toast.error(`${res.data.data}`);
      } else {
        toast.error(`${res.data.data.Result}`);
      }
    } catch (error) {
      console.log("API ERROR", error);
    }
  };

  //Notification start
  // const [NotificationCount, setNotificationCount] = useState("");
  // const getNotification = async () => {
  //   try {
  //     let res = await API.get(`/GetNotificationuserCount?uid=${userId}`);
  //     setNotificationCount(res.data.data.result);
  //   } catch (e) {
  //     console.log("Error", e);
  //   }
  // };
  // Notification end
  useEffect(() => {
    MyTeam_API();
    // getNotification();
  }, []);

  // const handleSearch = () => {
  //   // console.log("userid", userid);

  //   const sanitizedUid = DOMPurify.sanitize(userid);
  //   MyTeam_API(sanitizedUid);
  // };

  const indexOfLastPost = currentPage * listPerpage;

  function handleInput(e) {
    e.target.value = e.target.value.replace(/[^0-9]/, "").substring(0, 6);
    setUserId(e.target.value);
  }
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  // Toggle sidebar function
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };
  const tabLinks = document.querySelectorAll(".tab-link");
  const tabContents = document.querySelectorAll(".tab-content");

  tabLinks.forEach((link) => {
    link.addEventListener("click", () => {
      // Remove active class from all links
      tabLinks.forEach((link) => link.classList.remove("active"));
      // Add active class to clicked link
      link.classList.add("active");
      settabname(link);

      // Hide all tab contents
      tabContents.forEach((content) => content.classList.remove("active"));

      // Show current tab content
      const targetTab = document.getElementById(link.dataset.tab);
      targetTab.classList.add("active");
    });
  });

  return (
    <>
      <div className="container-fluid NewDashboard Activate_History">
        <div className="row">
          <div
            className={` ${isSidebarOpen ? "sidebar-open" : "sidebar-closed"}`}
          >
            <SidebarBOT />
          </div>
          <div className="col-lg-2 px-0 order-2">
            <div className="sidebarLeft px-3 position-relative">
              <div className="leftisidelogo">
                <img className="h-100 w-100" src={logo} alt="" />
              </div>
              <ul className="itemssidebar">
                <li>
                  <Link className="Anker" to="">
                    <div className="icon">
                      <img className="w-100 h-100" src={IconA} alt="" />
                    </div>{" "}
                    MAGIC Investment
                  </Link>
                  {dash?.BOTpackage}
                </li>
                <li>
                  <Link className="Anker" to="">
                    <div className="icon">
                      <img className="w-100 h-100" src={IconA} alt="" />
                    </div>{" "}
                    FOREX Investment
                  </Link>
                  {dash?.Forexpackage}
                </li>
                <li>
                  <Link
                    to=""
                    className="Anker w-100"
                    id="txtchangevalue"
                    value="Withdrawal"
                    // onClick={() => OnHandleWithdrawalLink()}
                  >
                    <div className="icon">
                      <img className="w-100 h-100" src={IconA} alt="" />
                    </div>{" "}
                    Total Income
                  </Link>
                  ${dash.TotalIncome}
                </li>
                <li>
                  <Link
                    to=""
                    className="Anker w-100"
                    id="txtchangevalue"
                    value="Withdrawal"
                    // onClick={() => OnHandleWithdrawalLink()}
                  >
                    <div className="icon">
                      <img className="w-100 h-100" src={IconA} alt="" />
                    </div>{" "}
                    Withdrawal Amount
                  </Link>
                  ${dash.WithDrawal_Amount}
                </li>
                <li>
                  <Link className="Anker" to="">
                    <div className="icon">
                      <img className="w-100 h-100" src={IconA} alt="" />
                    </div>{" "}
                    Net Balance
                  </Link>{" "}
                  ${dash?.Net_Balance}
                </li>
              </ul>
            </div>
          </div>
          <div className="col-lg-10 px-0 order-lg-2 order-1">
            <div className="contentside">
              <div className="row mx-0">
                <div className="col-12 px-0">
                  <header className="header ps-0">
                    <div className="hdleft d-flex align-items-center">
                      <div className="namelogo ps-3"></div>
                    </div>
                    <div className="rightside">
                      <div className="dropdown dropdow2 d-none d-md-block">
                        <Link
                          className="btn btnsecondary dropdown-toggle"
                          to=""
                          role="button"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          <span className="text1">
                            <p className="mb-1">ID Number</p>
                            <p className="mb-0 fw-bold text-start">{userId} </p>
                          </span>
                          <span className="icon">
                            <div className="name">
                              <img className="w-100 h-100" src={logo} alt="" />
                            </div>
                          </span>
                        </Link>

                        <ul className="dropdown-menu p-2">
                          <li className="text-white walltadd">
                            {dash?.f_name}
                          </li>
                        </ul>
                      </div>
                      <div className="dropdown dropdow2 d-block d-md-none">
                        <Link
                          className="btn btnsecondary dropdown-toggle"
                          to=""
                          role="button"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          <span className="icon">
                            <div className="name">
                              <img className="w-100 h-100" src={logo} alt="" />
                            </div>
                          </span>
                        </Link>

                        <ul className="dropdown-menu">
                          <li>
                            <Link className="dropdown-item" to="#">
                              Id Number <span>{userId}</span>
                            </Link>
                          </li>
                          <li className="text-white walltadd">
                            {dash?.f_name}
                          </li>
                        </ul>
                      </div>
                      <a href="/DashboardFIX">
                        <button className="btn headerbtn">FIX PLAN</button>
                      </a>
                      <a href="/DashboardBOT">
                        <button className="btn headerbtn">MAGIC PLAN</button>
                      </a>
                      <button
                        className="btn border-0 togglebtn"
                        id="togglebtn"
                        onClick={toggleSidebar}
                      >
                        <i
                          className={`fas fa-bars text-white ${
                            isSidebarOpen ? "" : "collapsed"
                          }`}
                        ></i>
                      </button>
                    </div>
                  </header>
                </div>
              </div>
              <div className="row mx-0">
                <div className="col-12">
                  <div className="contentsidesec w-100 pt-3">
                    <div className="row mx-0">
                      <div className="col-lg-12">
                        <div className="profile card card-body px-3 pt-3 pb-0">
                          <div className="profile-head">
                            <div className="photo-content">
                              <div className="cover-photo rounded" />
                            </div>
                            <div className="profile-info">
                              <div className="profile-photo">
                                <img
                                  src={trade}
                                  className="img-fluid rounded-circle"
                                  alt=""
                                  style={{ width: "100px" }}
                                />
                              </div>
                              <div className="profile-details">
                                <div className="profile-name px-3 pt-3">
                                  <h4 className="text-primary mb-0">
                                    {profileData?.f_name}
                                  </h4>
                                  <p>{profileData?.countryname}</p>
                                </div>
                                <div className="profile-email mt-3 px-2 pt-2">
                                  <h4 className="text-muted mb-0">
                                    {profileData?.email}
                                  </h4>
                                  <p>Email</p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <br></br>
                    <div className="row mx-0">
                      <div class="col-xl-12">
                        <div class="card">
                          <div class="card-body">
                            <div className="tabs-container">
                              <div className="col-12">
                                <div className="hostorheading">
                                  <ul
                                    className="nav nav-pills"
                                    id="pills-tab"
                                    role="tablist"
                                  >
                                    <li
                                      className="nav-item"
                                      role="presentation"
                                    >
                                      <button
                                        className="btn border-0 headingHistory nav-link active"
                                        id="pills-Deposit-tab"
                                        data-bs-toggle="pill"
                                        data-bs-target="#pills-Deposit"
                                        type="button"
                                        role="tab"
                                        aria-controls="pills-Deposit"
                                        aria-selected="true"
                                      >
                                        Profile
                                      </button>
                                    </li>
                                    <li>
                                      <button
                                        className="btn border-0 headingHistory nav-link"
                                        id="pills-Withdrawl-tab"
                                        data-bs-toggle="pill"
                                        data-bs-target="#pills-Withdrawl"
                                        type="button"
                                        role="tab"
                                        aria-controls="pills-Withdrawl"
                                        aria-selected="false"
                                      >
                                        Change Profile Password
                                      </button>
                                    </li>
                                    <li>
                                      <button
                                        className="btn border-0 headingHistory nav-link"
                                        id="pills-tab-tab3"
                                        data-bs-toggle="pill"
                                        data-bs-target="#pills-tab3"
                                        type="button"
                                        role="tab"
                                        aria-controls="pills-tab3"
                                        aria-selected="false"
                                      >
                                        Bank Details
                                      </button>
                                    </li>
                                    <li>
                                      <button
                                        className="btn border-0 headingHistory nav-link"
                                        id="pills-tab4-tab"
                                        data-bs-toggle="pill"
                                        data-bs-target="#pills-tab4"
                                        type="button"
                                        role="tab"
                                        aria-controls="pills-tab4"
                                        aria-selected="false"
                                      >
                                        BEP-20 Address Update
                                      </button>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                              <div
                                className="tab-content"
                                id="pills-tabContent"
                              >
                                <div
                                  className="tab-pane fade show active"
                                  id="pills-Deposit"
                                  role="tabpanel"
                                  aria-labelledby="pills-Deposit-tab"
                                  tabIndex={0}
                                >
                                  <div className="col-12">
                                    <form className="contact-form mt-3">
                                      <div className="row">
                                        <div className="col-md-12">
                                          <h2 className="text-black">
                                            Edit Profile
                                          </h2>
                                        </div>
                                        <div className="col-md-6">
                                          <label htmlFor="name">Name:</label>
                                          <input
                                            disabled={parseInt(AStatus) === 1}
                                            type="text"
                                            id="name"
                                            placeholder="Your Name"
                                            onChange={(e) => {
                                              setProfileName(e.target.value);
                                            }}
                                            value={ProfileName}
                                          />
                                        </div>
                                        <div className="col-md-6">
                                          <label htmlFor="email">Email:</label>
                                          <input
                                            disabled={parseInt(AStatus) === 1}
                                            type="email"
                                            id="email"
                                            placeholder="Your Email"
                                            onChange={(e) => {
                                              setEmail(e.target.value);
                                            }}
                                            value={Email}
                                          />
                                        </div>
                                        <div className="col-md-6">
                                          <label htmlFor="email">Mobile:</label>
                                          <input
                                            disabled={parseInt(AStatus) === 1}
                                            type="email"
                                            id="email"
                                            placeholder="1234567891"
                                            onChange={(e) => {
                                              setMobileNo(e.target.value);
                                            }}
                                            value={MobileNo}
                                          />
                                        </div>
                                        <div className="col-md-6">
                                          <label htmlFor="email">
                                            Country:
                                          </label>
                                          <select
                                            id="country"
                                            name="country"
                                            class="form-control countryselect"
                                            value={CountryId}
                                            onChange={(e) => {
                                              checkCountry(e);
                                            }}
                                            disabled={parseInt(AStatus) === 1}
                                          >
                                            <option value="" disabled>
                                              Select Country
                                            </option>
                                            {countries.map((country, index) => (
                                              <option
                                                key={index}
                                                value={country.id}
                                              >
                                                {country.name}
                                              </option>
                                            ))}
                                          </select>
                                        </div>

                                        <div className="col-md-6">
                                          <label htmlFor="email">State:</label>
                                          <select
                                            id="state"
                                            name="state"
                                            class="form-control countryselect"
                                            value={stateNewList}
                                            onChange={(e) => {
                                              checkState(e);
                                            }}
                                            disabled={parseInt(AStatus) === 1}
                                          >
                                            <option value="" disabled>
                                              Select State
                                            </option>
                                            {stateList?.map((state, index) => (
                                              <option
                                                key={index}
                                                value={state?.id}
                                                name={state?.name}
                                              >
                                                {state?.name}
                                              </option>
                                            ))}
                                          </select>
                                        </div>

                                        <div className="col-md-6">
                                          <label htmlFor="email">
                                            District:
                                          </label>
                                          <select
                                            id="country"
                                            name="country"
                                            class="form-control countryselect"
                                            value={districtNewList}
                                            onChange={(e) => {
                                              checkDistrict(e);
                                            }}
                                            disabled={parseInt(AStatus) === 1}
                                          >
                                            <option value="" disabled>
                                              Select District
                                            </option>
                                            {districtList.map((dis, index) => (
                                              <option
                                                key={index}
                                                value={dis?.id}
                                              >
                                                {dis?.name}
                                              </option>
                                            ))}
                                          </select>
                                        </div>
                                        <div className="col-md-6">
                                          <label htmlFor="pincode">Pin:</label>
                                          <input
                                            type="text"
                                            id="pincode"
                                            placeholder="Enter Pin"
                                            value={pincode}
                                            onChange={(e) => {
                                              checkpin(e);
                                            }}
                                            maxLength={6}
                                            disabled={parseInt(AStatus) === 1}
                                          />
                                        </div>
                                      </div>

                                      <button
                                        type="button"
                                        className="cta-btn"
                                        onClick={Updateprofile}
                                      >
                                        Submit
                                      </button>
                                    </form>
                                  </div>
                                </div>
                                <div
                                  className="tab-pane fade"
                                  id="pills-Withdrawl"
                                  role="tabpanel"
                                  aria-labelledby="pills-Withdrawl-tab"
                                  tabIndex={0}
                                >
                                  <div className="col-12">
                                    <form className="contact-form mt-3">
                                      <div className="row">
                                        <div className="col-md-12">
                                          <h2 className="text-black">
                                            Profile Password Setting
                                          </h2>
                                        </div>
                                        <div className="col-md-12">
                                          <label htmlFor="currentpassword">
                                            Current Password :
                                          </label>
                                          <input
                                            type="password"
                                            id="currentpassword"
                                            placeholder="Current Password "
                                            onChange={(e) => {
                                              setCcpassword(e.target.value);
                                            }}
                                          />
                                        </div>
                                        <div className="col-md-12">
                                          <label htmlFor="newpassword">
                                            New Password :
                                          </label>
                                          <input
                                            type="password"
                                            id="newpassword"
                                            placeholder="New Password "
                                            maxLength={20}
                                            onChange={(e) => {
                                              setPassword(e.target.value);
                                            }}
                                          />
                                        </div>

                                        <div className="col-md-12">
                                          <label htmlFor="confirmpassword">
                                            Confirm Password :
                                          </label>
                                          <input
                                            type="password"
                                            id="confirmpassword"
                                            placeholder="Confirm Password "
                                            maxLength={20}
                                            onChange={(e) => {
                                              setCpassword(e.target.value);
                                            }}
                                          />
                                        </div>
                                        <button
                                          type="button"
                                          className="cta-btn"
                                          onClick={Updateprofilepassword}
                                        >
                                          Update
                                        </button>
                                      </div>
                                    </form>
                                  </div>
                                </div>
                                <div
                                  className="tab-pane fade"
                                  id="pills-tab3"
                                  role="tabpanel"
                                  aria-labelledby="pills-tab-tab3"
                                  tabIndex={0}
                                >
                                  <div className="col-12">
                                    <form className="contact-form mt-3">
                                      <div className="row">
                                        <div className="col-md-6">
                                          <label htmlFor="name">
                                            Account Holder Name :
                                          </label>
                                          <input
                                            disabled={
                                              parseInt(AStatus) === 1 &&
                                              !HolderName
                                            }
                                            type="text"
                                            id="name"
                                            placeholder="Account Holder Name"
                                            value={HolderName}
                                            onChange={(e) => {
                                              setHolderName(e.target.value);
                                            }}
                                          />
                                        </div>
                                        <div className="col-md-6">
                                          <label htmlFor="name">
                                            Account No. :
                                          </label>
                                          <input
                                            disabled={
                                              parseInt(AStatus) === 1 &&
                                              !BankAccountNo
                                            }
                                            type="text"
                                            id="name"
                                            placeholder="Acount No."
                                            value={BankAccountNo}
                                            onChange={(e) => {
                                              setBankAccountNo(e.target.value);
                                            }}
                                          />
                                        </div>
                                        <div className="col-md-4">
                                          <label htmlFor="name">
                                            IFSC Code.:
                                          </label>
                                          <input
                                            disabled={
                                              parseInt(AStatus) === 1 &&
                                              !IFSCode
                                            }
                                            type="text"
                                            id="name"
                                            placeholder="IFSCode"
                                            value={IFSCode}
                                            onChange={(e) => {
                                              fetchBankDetails(e.target.value);
                                            }}
                                          />
                                        </div>
                                        <div className="col-md-4">
                                          <label htmlFor="name">
                                            Bank Name :
                                          </label>
                                          <input
                                            disabled={parseInt(AStatus) === 1}
                                            type="text"
                                            id="name"
                                            placeholder="Bank name"
                                            value={BankName}
                                            onChange={(e) => {
                                              setBankName(e.target.value);
                                            }}
                                            readOnly
                                          />
                                        </div>
                                        <div className="col-md-4">
                                          <label htmlFor="name">
                                            Branch Name :
                                          </label>
                                          <input
                                            disabled={parseInt(AStatus) === 1}
                                            type="text"
                                            id="name"
                                            placeholder="Branch Name"
                                            value={BranchName}
                                            onChange={(e) => {
                                              setBranchName(e.target.value);
                                            }}
                                            readOnly
                                          />
                                        </div>

                                        <div className="col-md-6">
                                          <label htmlFor="email">
                                            One Time Password :
                                          </label>
                                          <input
                                            type="email"
                                            id="email"
                                            placeholder="Enter One Time Password"
                                            onChange={(e) => {
                                              setBankotp_flag(e.target.value);
                                            }}
                                          />
                                          <button
                                            type="button"
                                            className="sendotp"
                                            onClick={sendBankOTP}
                                          >
                                            Send OTP
                                          </button>
                                        </div>
                                        <button
                                          type="button"
                                          style={{
                                            display: Bankotp_flag
                                              ? "block"
                                              : "none",
                                          }}
                                          className="cta-btn"
                                          onClick={UpdateBankDetails}
                                        >
                                          Update
                                        </button>
                                      </div>
                                    </form>
                                  </div>
                                </div>
                                <div
                                  className="tab-pane fade"
                                  id="pills-tab4"
                                  role="tabpanel"
                                  aria-labelledby="pills-tab4-tab"
                                  tabIndex={0}
                                >
                                  <div className="col-12">
                                    <form className="contact-form mt-3">
                                      <div className="row">
                                        <div className="col-md-6">
                                          <label htmlFor="name">
                                            E-Currency Address (BEP20) :
                                          </label>
                                          <input
                                            // disabled={
                                            //   profileData?.accountnumber
                                            // }
                                            disabled={parseInt(AStatus) === 1}
                                            type="text"
                                            id="name"
                                            placeholder="E-Currency Address"
                                            value={ecurrencyNew}
                                            onChange={(e) => {
                                              setecurrencyNew(e.target.value);
                                            }}
                                          />
                                        </div>

                                        <div
                                          className="col-md-6"
                                          style={{
                                            display:
                                              profileData?.accountnumber &&
                                              parseInt(AStatus) === 1
                                                ? "none"
                                                : "block",
                                          }}
                                        >
                                          <label htmlFor="email">
                                            One Time Password :
                                          </label>
                                          <input
                                            type="email"
                                            id="email"
                                            placeholder="Enter One Time Password"
                                            onChange={(e) => {
                                              setotp_flag(e.target.value);
                                            }}
                                          />
                                          <button
                                            type="button"
                                            className="sendotp"
                                            onClick={sendOTP}
                                            style={{
                                              display:
                                                profileData?.accountnumber &&
                                                parseInt(AStatus) === 1
                                                  ? "none"
                                                  : "block",
                                            }}
                                          >
                                            Send OTP
                                          </button>
                                        </div>
                                        <button
                                          type="button"
                                          style={{
                                            display:
                                              profileData?.accountnumber &&
                                              parseInt(AStatus) === 1
                                                ? "none"
                                                : "block",
                                          }}
                                          className="cta-btn"
                                          onClick={Updatewallet}
                                        >
                                          Update
                                        </button>
                                      </div>
                                    </form>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
